/* Modulo «Richiedi un reso» FAR — logica della pagina /pages/richiedi-reso (sezione far-reso-modulo), 19/10/2026.
   Il browser controlla i campi, raccoglie fino a 3 foto e manda tutto in POST multipart al server FAR dei resi
   ({server}/api/reso, campi order, email, reason, note, photo1..photo3, lang, privacy, customer_id);
   il server ritrova l'ordine e apre la richiesta di reso in Shopify. Risposta: {ok:true,id,orderName,status}
   oppure {ok:false,key,message}. I testi e i messaggi (5 lingue) arrivano dalla sezione (JSON data-frm-config). */
(function(){
  'use strict';
  var root=document.querySelector('[data-far-reso]');
  if(!root)return;
  var cfgEl=root.querySelector('[data-frm-config]');
  if(!cfgEl)return;
  var cfg;try{cfg=JSON.parse(cfgEl.textContent);}catch(e){return;}
  var form=root.querySelector('[data-frm-form]');
  if(!form||!cfg.api)return;
  var T=cfg.text||{},E=cfg.errors||{};
  var $=function(s){return root.querySelector(s);};
  var orderSel=$('[data-frm-order-select]'),orderManual=$('[data-frm-order-manual]'),orderIn=$('[data-frm-order]');
  var email=$('[data-frm-email]'),reason=$('[data-frm-reason]'),note=$('[data-frm-note]');
  var photoIn=$('[data-frm-photos]'),photoBtn=$('[data-frm-photos-add]'),list=$('[data-frm-photo-list]'),count=$('[data-frm-photo-count]');
  var privacy=$('[data-frm-privacy]'),submit=$('[data-frm-submit]'),submitLabel=$('[data-frm-submit-label]');
  var topErr=$('[data-frm-error-top]'),status=$('[data-frm-status]'),success=$('[data-frm-success]');
  var api=String(cfg.api).replace(/\/+$/,''),MAX=cfg.maxPhotos||3,MAXSIZE=cfg.maxSize||8388608;
  var photos=[],busyNow=false;

  function fmt(s,map){return String(s||'').replace(/\{(\w+)\}/g,function(m,k){return map&&map[k]!=null?String(map[k]):m;});}
  var INPUTS={order:['order','order-manual']};
  function fieldErr(name,msg){
    var p=root.querySelector('[data-frm-field-error="'+name+'"]');
    if(p){p.textContent=msg||'';p.hidden=!msg;}
    var names=INPUTS[name]||[name];
    for(var n=0;n<names.length;n++){
      var inputs=root.querySelectorAll('[data-frm-input="'+names[n]+'"]');
      for(var i=0;i<inputs.length;i++){if(msg)inputs[i].setAttribute('aria-invalid','true');else inputs[i].removeAttribute('aria-invalid');}
    }
  }
  function clearTop(){topErr.hidden=true;topErr.textContent='';}
  function showTop(msg,focus){
    topErr.textContent=msg;topErr.hidden=false;
    if(focus){try{topErr.focus();}catch(e){}}
    if(topErr.scrollIntoView){try{topErr.scrollIntoView({block:'center',behavior:'smooth'});}catch(e){topErr.scrollIntoView();}}
  }
  function focusField(el){if(!el)return;try{el.focus({preventScroll:true});}catch(e){try{el.focus();}catch(x){}}if(el.scrollIntoView){try{el.scrollIntoView({block:'center',behavior:'smooth'});}catch(e){}}}

  // Ordine: tendina con gli ordini dell'account (cliente entrato) oppure campo di testo.
  function manualOn(){return !orderSel||orderSel.value==='__other__';}
  if(orderSel){
    orderSel.addEventListener('change',function(){
      var other=orderSel.value==='__other__';
      orderManual.hidden=!other;
      if(other)focusField(orderIn);
      fieldErr('order','');
    });
  }
  function orderValue(){
    if(!manualOn())return String(orderSel.value||'').trim();
    return String(orderIn.value||'').trim().replace(/^#+/,'').replace(/\s+/g,'');
  }
  orderIn.addEventListener('input',function(){fieldErr('order','');});
  email.addEventListener('input',function(){fieldErr('email','');});
  reason.addEventListener('change',function(){fieldErr('reason','');if(reason.value!=='other')fieldErr('note','');});
  note.addEventListener('input',function(){fieldErr('note','');});
  privacy.addEventListener('change',function(){fieldErr('privacy','');});

  // Foto: fino a 3, JPG/PNG/HEIC/WEBP, 8 MB l'una. La lista vive qui; il campo file si svuota dopo ogni scelta.
  function okType(f){
    var t=String(f.type||'').toLowerCase(),n=String(f.name||'').toLowerCase();
    if(/^image\/(jpeg|jpg|pjpeg|png|webp|heic|heif|heic-sequence|heif-sequence)$/.test(t))return true;
    if(t&&t.indexOf('image/')!==0)return false;
    return /\.(jpe?g|png|webp|heic|heif)$/.test(n);
  }
  function mb(b){var v=b/1048576,s=v>=10?String(Math.round(v)):v.toFixed(1);return (cfg.lang==='en'?s:s.replace('.',','))+' MB';}
  function addFiles(files){
    var errs=[];
    for(var i=0;i<files.length;i++){
      var f=files[i];
      if(photos.length>=MAX){errs.push(E.photo_count);break;}
      if(!okType(f)){errs.push(fmt(E.photo_type,{name:f.name}));continue;}
      if(f.size>MAXSIZE){errs.push(fmt(E.photo_too_big,{name:f.name}));continue;}
      photos.push(f);
    }
    render();
    fieldErr('photos',errs.length?errs.join(' '):'');
  }
  function render(){
    list.innerHTML='';
    photos.forEach(function(f,i){
      var li=document.createElement('li');li.className='frm-photo';
      var th=document.createElement('span');th.className='frm-photo-thumb';th.setAttribute('aria-hidden','true');
      if(/^image\/(jpeg|jpg|png|webp)$/.test(String(f.type||''))&&window.URL&&URL.createObjectURL){
        var img=document.createElement('img');img.alt='';var u=URL.createObjectURL(f);img.src=u;
        img.onload=function(){try{URL.revokeObjectURL(u);}catch(e){}};th.appendChild(img);
      }else th.textContent=(String(f.name||'').split('.').pop()||'IMG').toUpperCase().slice(0,4);
      var nm=document.createElement('span');nm.className='frm-photo-name';nm.textContent=f.name;
      var sm=document.createElement('small');sm.textContent=mb(f.size);nm.appendChild(sm);
      var rm=document.createElement('button');rm.type='button';rm.className='frm-photo-remove';rm.textContent=T.photoRemove||'×';
      rm.setAttribute('aria-label',(T.photoRemove||'')+' '+f.name);
      rm.addEventListener('click',function(){photos.splice(i,1);render();fieldErr('photos','');});
      li.appendChild(th);li.appendChild(nm);li.appendChild(rm);list.appendChild(li);
    });
    count.textContent=fmt(T.photosCount,{n:photos.length});
    photoBtn.hidden=photos.length>=MAX;
  }
  photoBtn.addEventListener('click',function(){photoIn.click();});
  photoIn.addEventListener('change',function(){if(photoIn.files&&photoIn.files.length)addFiles(photoIn.files);photoIn.value='';});
  render();

  function validate(){
    var ok=true,first=null;
    function bad(name,msg,el){ok=false;fieldErr(name,msg);if(!first)first=el;}
    var o=orderValue();
    if(!o)bad('order',E.order_required,manualOn()?orderIn:orderSel);
    else if(!/^[A-Za-z0-9][A-Za-z0-9._-]{0,23}$/.test(o))bad('order',E.order_invalid,orderIn);
    else fieldErr('order','');
    var em=String(email.value||'').trim();
    if(!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(em))bad('email',E.email_invalid,email);else fieldErr('email','');
    if(!reason.value)bad('reason',E.reason_required,reason);else fieldErr('reason','');
    var n=String(note.value||'').trim();
    if(reason.value==='other'&&n.length<5)bad('note',E.note_required,note);else fieldErr('note','');
    if(!privacy.checked)bad('privacy',E.privacy,privacy);else fieldErr('privacy','');
    if(!ok){showTop(E.form,false);focusField(first);}
    return ok;
  }

  function busy(on,label){
    busyNow=on;submit.disabled=on;submitLabel.textContent=label||T.submit;
    var els=form.querySelectorAll('input:not([data-frm-locked]),select,textarea,button');
    for(var i=0;i<els.length;i++){if(els[i]!==submit)els[i].disabled=on;}
  }

  function showSuccess(j){
    var o=orderValue(),orderName=j.orderName||('#'+o);
    form.hidden=true;
    var who=$('[data-frm-who]'),login=$('[data-frm-login]');if(who)who.hidden=true;if(login)login.hidden=true;
    $('[data-frm-success-text]').textContent=fmt(T.successText,{email:String(email.value||'').trim()});
    $('[data-frm-success-status]').textContent=fmt(j.status==='noted'?T.statusNoted:T.statusRequested,{order:orderName});
    var idRow=$('[data-frm-success-id-row]');
    if(j.id){$('[data-frm-success-id]').textContent=String(j.id);idRow.hidden=false;}else idRow.hidden=true;
    $('[data-frm-sum-order]').textContent=orderName;
    $('[data-frm-sum-email]').textContent=String(email.value||'').trim();
    var opt=reason.options[reason.selectedIndex];
    $('[data-frm-sum-reason]').textContent=opt?opt.text:reason.value;
    $('[data-frm-sum-note]').textContent=String(note.value||'').trim()||'—';
    $('[data-frm-sum-photos]').textContent=photos.length?photos.map(function(f){return f.name;}).join(', '):(T.photosNone||'—');
    success.hidden=false;
    var h=$('[data-frm-success-title]');try{h.focus({preventScroll:true});}catch(e){try{h.focus();}catch(x){}}
    if(success.scrollIntoView){try{success.scrollIntoView({block:'start',behavior:'smooth'});}catch(e){}}
  }

  $('[data-frm-again]').addEventListener('click',function(){
    success.hidden=true;form.hidden=false;
    var who=$('[data-frm-who]'),login=$('[data-frm-login]');if(who)who.hidden=false;if(login)login.hidden=false;
    if(orderSel){orderSel.value='';orderManual.hidden=true;}
    orderIn.value='';reason.value='';note.value='';privacy.checked=false;photos=[];render();
    if(!email.hasAttribute('readonly'))email.value='';
    ['order','email','reason','note','photos','privacy'].forEach(function(n){fieldErr(n,'');});
    clearTop();focusField(orderSel||orderIn);
  });

  form.addEventListener('submit',function(e){
    e.preventDefault();
    if(busyNow)return;
    clearTop();
    if(!validate())return;
    var fd=new FormData();
    fd.append('order',orderValue());
    fd.append('email',String(email.value||'').trim());
    fd.append('reason',reason.value);
    fd.append('note',String(note.value||'').trim());
    photos.forEach(function(f,i){fd.append('photo'+(i+1),f,f.name);});
    fd.append('lang',cfg.lang||'it');
    fd.append('privacy','1');
    if(cfg.customerId)fd.append('customer_id',String(cfg.customerId));
    busy(true,T.submitting);
    status.textContent=photos.length?T.uploading:T.submitting;status.hidden=false;
    var ctrl=(typeof AbortController==='function')?new AbortController():null;
    var timer=ctrl?setTimeout(function(){ctrl.abort();},120000):null;
    var opt={method:'POST',body:fd,mode:'cors',credentials:'omit'};
    if(ctrl)opt.signal=ctrl.signal;
    fetch(api+'/api/reso',opt).then(function(r){
      return r.json().then(function(j){return {r:r,j:j||{}};},function(){return {r:r,j:{}};});
    },function(){var e=new Error(E.network);e.key='network';throw e;}).then(function(x){
      var r=x.r,j=x.j;
      if(r.ok&&j.ok)return j;
      var key=j.key||'generic',msg=E[key]||(j.message?String(j.message):'')||E.generic;
      var e=new Error(msg);e.key=key;throw e;
    }).then(function(j){showSuccess(j);},function(err){showTop(err&&err.message?err.message:E.generic,true);}).then(function(){
      if(timer)clearTimeout(timer);busy(false);status.hidden=true;status.textContent='';
    });
  });
})();
